import { useEffect, useState } from 'react';

/**
 * Telefone em pé ou deitado. O mesmo critério está no CSS, no bloco `@media`.
 *
 * Deitado, a largura passa de 760px (um iPhone fica perto de 840–960). Sem a
 * segunda cláusula o mosaico de desktop parte a tela ao meio e o TUI fica
 * ilegível. Uma janela de computador é mais alta que 500px, então não entra.
 */
export const NARROW_QUERY =
  '(max-width: 760px), (max-height: 500px) and (max-width: 1024px)';

export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(NARROW_QUERY).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(NARROW_QUERY);
    const apply = () => setNarrow(mq.matches);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);

  return narrow;
}

/**
 * Publica a altura que o usuário realmente vê.
 *
 * No celular, `100vh` inclui a área que o teclado cobre. Sem isto o terminal
 * continua do tamanho da tela inteira e a linha que se está digitando fica
 * escondida atrás do teclado.
 */
export function useVisualViewportBox(): void {
  useEffect(() => {
    const vv = window.visualViewport;
    const root = document.documentElement;
    if (!vv) return;

    const apply = () => {
      root.style.setProperty('--vvh', `${Math.round(vv.height)}px`);
      root.style.setProperty('--vv-top', `${Math.round(vv.offsetTop)}px`);
    };

    apply();
    vv.addEventListener('resize', apply);
    vv.addEventListener('scroll', apply);
    return () => {
      vv.removeEventListener('resize', apply);
      vv.removeEventListener('scroll', apply);
      root.style.removeProperty('--vvh');
      root.style.removeProperty('--vv-top');
    };
  }, []);
}
